import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import '../styles/NewsletterPopup.css';
import { useTranslations } from '../hooks/useTranslations';

const NewsletterPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubscribing, setSubscribing] = useState(false);
  const [subscriptionSuccessful, setSubscriptionSuccessful] = useState(false);
  const { t } = useTranslations();

  useEffect(() => {
    const popupTimer = setTimeout(() => {
      setShowPopup(true);
    }, 2000);

    return () => clearTimeout(popupTimer);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = (event) => {
    event.preventDefault();
    setSubscribing(true);
    const newsUrl = process.env.REACT_APP_API_URL_NEWS || 'http://localhost:3001/news/send-news';

    const request = fetch(newsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to subscribe: ${response.statusText}`);
        }
        setSubscriptionSuccessful(true);
        setEmail('');
        setTimeout(() => {
          setSubscriptionSuccessful(false);
        }, 2000);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setSubscribing(false);
      });

    return request;
  };

  return (
    <>
      {showPopup && (
        <div className='popup-container' role="dialog" aria-modal="true" aria-labelledby="newsletter-heading">
          <div className="popup-frame">
            <button
              type="button"
              className="close-button-news"
              onClick={handleClose}
              aria-label={t('newsletter.close', 'Sulje uutiskirjeen tilausikkuna')}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="popup-content">
              <div className="main-content-news">
                <h1 id="newsletter-heading">{t('newsletter.heading', 'Tilaa uutiskirje')}</h1>
                <p>{t('newsletter.intro', 'Arvokkaita vinkkejä ja eksklusiivisia alennuksia Romanian lääketieteellisiin opintoihin hakeville.')}</p>

                <form className="input-container" onSubmit={handleSubscribe}>
                  <label htmlFor="newsletter-email" className="visually-hidden">
                    {t('newsletter.form.emailLabel', 'Sähköposti')}
                  </label>
                  <input
                    type="email"
                    id="newsletter-email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder={t('newsletter.form.emailPlaceholder', 'Sähköposti')}
                    required
                  />
                  <button type="submit" disabled={isSubscribing}>
                    {isSubscribing
                      ? t('newsletter.form.sending', 'Tilataan...')
                      : t('newsletter.form.submit', 'Tilaa')}
                  </button>
                </form>

                {subscriptionSuccessful && (
                  <div className="message-sent" role="status" aria-live="polite">
                    {t('newsletter.form.success', '✓ Tilauksesi on vastaanotettu!')}
                  </div>
                )}
              </div>

              <div className="right-content-news">
                <h2>{t('newsletter.sidebar.title', 'Sisällys')}</h2>
                <p>• {t('newsletter.sidebar.items.fees', 'Lukuvuosimaksut & Kelan tuet')}</p>
                <p>• {t('newsletter.sidebar.items.legalisation', 'Suomessa laillistuminen & työharjoittelut')}</p>
                <p>• {t('newsletter.sidebar.items.whyRomania', 'Miksi Romania & Romaniassa asuminen')}</p>
                <p>• {t('newsletter.sidebar.items.requirements', 'Lääketieteelliseen hakemisen edellytykset')}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsletterPopup;
